import withAPIAction from 'helpers/withAPIAction'
import { RoleListReq, CreateRoleReq, UpdateRoleReq, DeleteRoleReq, RoleDetailReq } from './types'
import {
  getRoleListAction,
  createRoleAction,
  updateRoleAction,
  deleteRoleAction,
  getRoleDetailAction,
  getAllRoleListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const roleListAPI = (data: RoleListReq, token: string, xmid: any) => {
  return withAPIAction<RoleListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.roleList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getRoleListAction)
}

export const allRoleListAPI = (data: RoleListReq, token: string, xmid: any) => {
  return withAPIAction<RoleListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.roleList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllRoleListAction)
}

export const createRoleAPI = (data: CreateRoleReq, token: string, xmid: string) => {
  return withAPIAction<CreateRoleReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createRole,
    data,
    token,
    xmid,
  })(createRoleAction)
}

export const updateRoleAPI = (data: UpdateRoleReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateRole.replace(':id', data.id.toString())
  return withAPIAction<UpdateRoleReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateRoleAction)
}

export const deleteRoleAPI = (data: DeleteRoleReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteRole.replace(':id', data.id.toString())
  return withAPIAction<DeleteRoleReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteRoleAction)
}

export const getRoleDetailAPI = (data: RoleDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getRoleByID.replace(':id', data.id.toString())
  return withAPIAction<RoleDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getRoleDetailAction)
}
